<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.form.get('id').value">Ajouter un site</h3>
      <h3 *ngIf="this.form.get('id').value">Modifier un site</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">
        <div class="col-sm-2">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" name="code" formControlName="code" maxlength="2" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
                <mat-error *ngIf="form.get('code').hasError('max')">
                    Le code est trop long
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="30" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('max')">
                Le libelle est trop long
            </mat-error>
            </mat-form-field>
        </div>

        
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Raison sociale</mat-label>
            <input matInput name="rSociale" formControlName="rSociale" maxlength="30">
            <mat-error *ngIf="form.get('rSociale').hasError('max')">
                Le numéro est trop long
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-2">
            <mat-form-field class="full-width">
            <mat-label>Type</mat-label>
            <input matInput name="type" formControlName="type" required maxlength="1">
            <mat-error *ngIf="form.get('type').hasError('required')">
                Veuillez saisir un type
            </mat-error>
            <mat-error *ngIf="form.get('type').hasError('max')">
                Le type est trop long
            </mat-error>
            </mat-form-field>
        </div>

            <div class="col-sm-4">
                <mat-form-field class="full-width">
                <mat-label>Adresse</mat-label>
                <input matInput name="adr1" formControlName="adr1"  maxlength="70">
                </mat-form-field>
            </div>
        
            <div class="col-sm-4">
                <mat-form-field class="full-width">
                <mat-label>Complément adresse</mat-label>
                <input matInput name="adr2" formControlName="adr2"  maxlength="70">
                </mat-form-field>
            </div>

            <div class="col-sm-4">
                <mat-form-field class="full-width">
                <mat-label>Code postal/Ville</mat-label>
                <input matInput name="adr3" formControlName="adr3"  maxlength="70">
                </mat-form-field>
            </div>
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Adresse de facturation</mat-label>
            <input matInput name="adrFact1" formControlName="adrFact1"  maxlength="70">
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Complément adresse de facturation</mat-label>
            <input matInput name="adrFact2" formControlName="adrFact2"  maxlength="70">
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Code postal/Ville de facturation</mat-label>
            <input matInput name="adrFact3" formControlName="adrFact3" maxlength="70">
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Téléphone</mat-label>
            <input matInput name="tel" formControlName="tel">
            <mat-error *ngIf="form.get('tel').hasError('max')">
                Le champ téléphone est trop long
            </mat-error>
            </mat-form-field>
        </div>
        
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Fax</mat-label>
            <input matInput name="fax" formControlName="fax">
            <mat-error *ngIf="form.get('fax').hasError('max')">
                Le champ fax est trop long
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <app-autocomplete-with-code-form   
              name="ca1" [parent]="form"  
              libelle="Ca1" 
              [objets]="ca1s" 
              [(objet)]="ca1">
            </app-autocomplete-with-code-form>
        </div>
  
        
        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Numéro de siret</mat-label>
            <input matInput name="siret1" formControlName="siret1" maxlength="9">
            <mat-error *ngIf="form.get('siret1').hasError('max')">
                Le numéro de SIRET est trop long
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>NAF</mat-label>
            <input matInput name="naf" formControlName="naf">
            <mat-error *ngIf="form.get('naf').hasError('max')">
                Le champ NAF est trop long
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input matInput name="email" formControlName="email">
            <mat-error *ngIf="form.get('email').hasError('max')">
                Le champ email est trop long
            </mat-error>
            </mat-form-field>
        </div> 
    </form> 
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>
    </div>
</div>

